const REDIRECT_START = 'settings/REDIRECT_START';
const REDIRECT_SUCCEEDED = 'settings/REDIRECT_SUCCEEDED';
const REDIRECT_REQUEST_START = 'settings/REDIRECT_REQUEST_START';

export default {
  REDIRECT_START,
  REDIRECT_SUCCEEDED,
  REDIRECT_REQUEST_START,
};
